import IframeMessageBroker from '@flywire/internal-components/services/iframeMessageBroker/iframeMessageBroker';
import type { InjectLRSAppearanceSettings } from '@flywire/internal-components/services/iframeMessageBroker/model';
import { MESSAGES } from '@flywire/internal-components/services/iframeMessageBroker/model';

import {
  type InternalElementFactoryOptions,
  type LRSElementPublicOptions,
  SdkElement
} from '../../../model';
import { EventBus, type EventBusType } from '../../EventBus';
import { createIframe } from '../createIframe';
import { lrsUrlBuilder } from './lrsUrlBuilder';

export type LRSElementOptions = LRSElementPublicOptions & InternalElementFactoryOptions;

export const LRSElement = (options: LRSElementOptions): SdkElement => {
  const { displayMode = 'full-screen' } = options;
  const eventBus = EventBus();

  const mount = (id?: string) => {
    const url = lrsUrlBuilder(options);
    const { iframe } = createIframe({
      containerId: id,
      src: url,
      displayMode,
      title: 'Flywire LRS Element',
      containerErrorKey: 'lrsElementContainerNotPresent'
    });

    sendAppearanceValuesToIframe(
      IframeMessageBroker.getInstance(),
      iframe,
      options.appearance,
      eventBus
    );
  };

  return {
    mount,
    onEvent: (key, fn) => eventBus.addEvent(key, fn),
    registeredEvents: eventBus.registeredEvents
  };
};

const sendAppearanceValuesToIframe = (
  broker: ReturnType<(typeof IframeMessageBroker)['getInstance']>,
  iframe: HTMLIFrameElement,
  appearance: InternalElementFactoryOptions['appearance'],
  eventBus: EventBusType
) => {
  broker.addListener(MESSAGES.LRS_ELEMENT_LOADED, () => {
    eventBus.onEvent('loaded', {});
    if (appearance) {
      broker.sendMessage<InjectLRSAppearanceSettings>(
        MESSAGES.INJECT_LRS_APPEARANCE_SETTINGS,
        { appearance: { ...appearance } },
        iframe
      );
    }
  });
};
